import React from 'react'

const TimePicker = props => {
  let schedule = props.schedule.split('-')

  let timeStart = new Date(`2011-04-20T${schedule[0]}`)
  let timeEnd = new Date(`2011-04-20T${schedule[1]}`)
  let sumTime = timeStart

  let timesInput = []


  //Fill the time dropdown | Not applicable with .map () for the length of the elements is immeasurable
  for (let i = 0; i < 100; i++) {
    if (timeStart.getTime() === sumTime.getTime()) {
      timesInput.push(
        <option
          key={`${sumTime.getHours()}:${sumTime.getMinutes()}`}
          value={`${(sumTime.getHours()<10?'0'+sumTime.getHours():sumTime.getHours())}:${(sumTime.getMinutes()<10?'0'+sumTime.getMinutes():sumTime.getMinutes())}:${(sumTime.getMinutes()<10?'0'+sumTime.getMinutes():sumTime.getMinutes())}`}
        >
          {`${(sumTime.getHours()<10?'0'+sumTime.getHours():sumTime.getHours())}:
          ${(sumTime.getSeconds()<10?'0'+sumTime.getSeconds():sumTime.getSeconds())}`}
        </option>
      )
      sumTime.setMinutes(sumTime.getMinutes() + 30)
    }
    if (timeEnd.getTime() >= sumTime.getTime()) {
      timesInput.push(
        <option
          key={`${sumTime.getHours()}:${sumTime.getMinutes()}`}
          value={`${(sumTime.getHours()<10?'0'+sumTime.getHours():sumTime.getHours())}:${(sumTime.getMinutes()<10?'0'+sumTime.getMinutes():sumTime.getMinutes())}:${(sumTime.getSeconds()<10?'0'+sumTime.getSeconds():sumTime.getSeconds())}`}
        >
          {`${(sumTime.getHours()<10?'0'+sumTime.getHours():sumTime.getHours())}:
          ${(sumTime.getMinutes()<10?'0'+sumTime.getMinutes():sumTime.getMinutes())}`}
        </option>
      )
      sumTime.setMinutes(sumTime.getMinutes() + 30)
    } else {
      break
    }
  }
  return (
    <div className="select-style time-picker">
      <select name={props.inputName} onChange={props.onChange}>
        <option value="">{props.label}</option>
        {timesInput}
      </select>
    </div>
  )
}
export default TimePicker




// WEBPACK FOOTER //
// ./src/components/MainForm/TimePicker.js